/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { useUIData } from "../hooks/useUIData";
import { RouteKeys } from "../../containers/routes/route-keys";
import { State } from "../../core/store/interfaces";
import SideSubMenu from "./SideSubMenu";
import { useOutsideClick } from "../hooks";
import { Link, useHistory } from "react-router-dom";
import { AppPermissions } from "../api/models/permissions";
import { useSelector } from "react-redux";
import api from "../../api";
import { useAppSettings } from "../hooks/useAppSettings";

const SideMenu: React.FunctionComponent<{
  showOpenHideMenu?: boolean;
  onMenuClose?: () => void;
  sidemenuRef?: React.MutableRefObject<any>;
}> = (props) => {
  const ui = useUIData();
  const history = useHistory();
  const [location, setLocation] = useState(history.location.pathname);
  const [sideMenu, setSideMenu] = useState<any>();

  useEffect(() => {
    return history.listen((loc) => {
      if (location !== loc.pathname) {
        setLocation(loc.pathname);
        ui.changeSideMenuExpandedStatus(false);
      }
    });
  }, [history, location]);

  const authState = useSelector((state: State) => state.authUser);
  // useOutsideClick(ref, () => {ui.changeSideMenuExpandedStatus(false);
  //   if (props?.onMenuClose){
  //     props?.onMenuClose()
  //   } });
  const appSettings = useAppSettings(api.settings);

  const permissions = {
    viewLeads: authState.apiPermissions?.[AppPermissions.ViewLeads],
    viewCustomer: authState.apiPermissions?.[AppPermissions.ViewCustomer],
    viewAllCustomers:
      authState.apiPermissions?.[AppPermissions.ViewAllCustomers],
    viewActivityCalendar:
      authState.apiPermissions?.[AppPermissions.ViewActivityCalendar],
    viewConfigurationReport:
      authState.apiPermissions?.[AppPermissions.ViewConfigurationReport],
    viewEmailReport: authState.apiPermissions?.[AppPermissions.ViewEmailReport],
    viewLeadCustomer360: authState.apiPermissions?.[AppPermissions.View360],
    viewVehicles: authState.apiPermissions?.[AppPermissions.ViewVehicles],
    viewVehicleVariant:
      authState.apiPermissions?.[AppPermissions.ViewVehicleVariant],
    updateVehicleVariant:
      authState.apiPermissions?.[AppPermissions.UpdateVehicleVariant],
    viewVinRequests: authState.apiPermissions?.[AppPermissions.ViewVinRequests],
    viewAllrequests: authState.apiPermissions?.[AppPermissions.ViewAllRequests],
    viewTradeIn: authState.apiPermissions?.[AppPermissions.ViewTradeIn],
    viewFinance: authState.apiPermissions?.[AppPermissions.ViewFinance],
    viewInsurance: authState.apiPermissions?.[AppPermissions.ViewCustomer],
    viewService: authState.apiPermissions?.[AppPermissions.ViewCustomer],
    viewApps: authState.apiPermissions?.[AppPermissions.ViewCampaigns],
    viewOfferRequests:
      authState.apiPermissions?.[AppPermissions.ViewVinRequests],

    viewShowrooms: authState.apiPermissions?.[AppPermissions.ViewShowrooms],

    viewRoles: authState.apiPermissions?.[AppPermissions.ViewRoles],

    viewVisiblityGroup:
      authState.apiPermissions?.[AppPermissions.ViewVisiblityGroup],

    viewStaffMembers:
      authState.apiPermissions?.[AppPermissions.ViewStaffMembers],
    updateStaffMembers:
      authState.apiPermissions?.[AppPermissions.UpdateStaffMembers],

    viewLeadIntent: authState.apiPermissions?.[AppPermissions.UpdateLeadIntent],
    viewLeadType: authState.apiPermissions?.[AppPermissions.ViewLeadType],
    viewLeadStatus: authState.apiPermissions?.[AppPermissions.ViewLeadStatus],
    tenancyExpiryTracker:
      authState.apiPermissions?.[AppPermissions.tenancyExpiryTracker],
    viewLeadNewness:
      authState.apiPermissions?.[AppPermissions.UpdateLeadNewness],
    viewDecisionTimeFrame:
      authState.apiPermissions?.[AppPermissions.UpdateDecisionTimeFrame],
    viewInitialTouchpoint:
      authState.apiPermissions?.[AppPermissions.ViewInitialTouchpoint],
    viewLeadSource: authState.apiPermissions?.[AppPermissions.ViewLeadSource],
    viewBusinessSource:
      authState.apiPermissions?.[AppPermissions.ViewBusinessSource],

    viewBuyingInfluence:
      authState.apiPermissions?.[AppPermissions.ViewBuyingInfluence],
    viewLeadQuality: authState.apiPermissions?.[AppPermissions.ViewLeadQuality],
    viewLeadReason: authState.apiPermissions?.[AppPermissions.ViewLeadQuality],

    viewLeadSettings:
      authState.apiPermissions?.[AppPermissions.UpdateLeadIntent] ||
      authState.apiPermissions?.[AppPermissions.ViewLeadType] ||
      authState.apiPermissions?.[AppPermissions.ViewLeadStatus] ||
      authState.apiPermissions?.[AppPermissions.UpdateLeadNewness] ||
      authState.apiPermissions?.[AppPermissions.UpdateDecisionTimeFrame] ||
      authState.apiPermissions?.[AppPermissions.ViewInitialTouchpoint] ||
      authState.apiPermissions?.[AppPermissions.ViewLeadSource] ||
      authState.apiPermissions?.[AppPermissions.ViewBusinessSource] ||
      authState.apiPermissions?.[AppPermissions.ViewBuyingInfluence] ||
      authState.apiPermissions?.[AppPermissions.ViewLeadQuality] ||
      authState.apiPermissions?.[AppPermissions.ViewLeadQuality],

    updateGeneralSettings:
      authState.apiPermissions?.[AppPermissions.UpdateGeneralSettings],

    viewContentSettings:
      authState.apiPermissions?.[AppPermissions.ViewContentSettings],

    viewDailySalesReport:
      authState.apiPermissions?.[AppPermissions.ViewDailySalesReportStaff] ||
      authState.apiPermissions?.[AppPermissions.ViewDailySalesReportVehicle],
    viewLeadConversionReport:
      authState.apiPermissions?.[AppPermissions.ViewLeadConversionReport],
    viewFollowupReport:
      authState.apiPermissions?.[AppPermissions.ViewFollowupReport],
    viewActivitySummaryReport:
      authState.apiPermissions?.[
        AppPermissions.ViewActivitySummaryReportStaff
      ] ||
      authState.apiPermissions?.[
        AppPermissions.ViewActivitySummaryReportVehicle
      ],
    viewCollectionSegregationReport:
      authState.apiPermissions?.[
        AppPermissions.ViewCollectionSegregationReport
      ],
    viewLostLeadReport:
      authState.apiPermissions?.[AppPermissions.ViewLostLeadReportStaff] ||
      authState.apiPermissions?.[AppPermissions.ViewLostLeadReportVehicle],

    viewTransferLeadReport:
      authState.apiPermissions?.[AppPermissions.ViewTransferLeadReport],

    viewPendingMKPayment:
      authState.apiPermissions?.[AppPermissions.PendingMKPayment],

    viewCustomerDataChangeReport:
      authState.apiPermissions?.[AppPermissions.ViewCustomerDataChangeReport],

    viewReport:
      authState.apiPermissions?.[AppPermissions.ViewActivitySummaryReport],

    viewLostRequest: authState.apiPermissions?.[AppPermissions.ViewLostRequest],

    viewCashDiscounts:
      authState.apiPermissions?.[AppPermissions.ViewCashDiscounts],

    viewMonthEndClosing:
      authState.apiPermissions?.[AppPermissions.ViewMonthEndClosingDetails],

    viewPoolDiscounts:
      authState.apiPermissions?.[AppPermissions.ViewPoolDiscounts],

    viewNetPriceCeiling:
      authState.apiPermissions?.[AppPermissions.ViewNetPriceCeiling],
    viewConfiguration:
      authState.apiPermissions?.[AppPermissions.ViewRequirement],

    viewBdcReport: authState.apiPermissions?.[AppPermissions.ViewBdcReport],
    viewTradeInDiscounts:
      authState.apiPermissions?.[AppPermissions.ViewTradeInDiscounts],

    // viewCombinedDiscounts:
    //   authState.apiPermissions?.[AppPermissions.ViewCombinedDiscounts],

    downloadCampaignSummary:
      authState.apiPermissions?.[AppPermissions.DownloadCampaignSummary],

    downloadReport: authState.apiPermissions?.[AppPermissions.DownloadReport],

    discountSummaryReport:
      authState.apiPermissions?.[AppPermissions.DiscountSummaryReport],

    viewOcrRecords: authState.apiPermissions?.[AppPermissions.ViewOcrRecords],
    viewAccessoryReport:
      authState.apiPermissions?.[AppPermissions.ViewAccessoryReport],

    viewCouponReport:
      authState.apiPermissions?.[AppPermissions.ViewCouponReport],

    viewInsuranceReport:
      authState.apiPermissions?.[AppPermissions.ViewInsuranceReport],

    viewServicePackageReport:
      authState.apiPermissions?.[AppPermissions.ViewServicePackageReport],

    viewBookingManipulationReport:
      authState.apiPermissions?.[AppPermissions.ViewBookingManipulationReport],

    viewWappReport: authState.apiPermissions?.[AppPermissions.WhatsappReport],

    approveDiscountCampaign:
      authState.apiPermissions?.[AppPermissions.ApproveDiscountCampaign],

    viewDiscountCampaigns:
      authState.apiPermissions?.[AppPermissions.ApproveDiscountCampaign] ||
      authState.apiPermissions?.[AppPermissions.UpdateDiscountCampaign] ||
      authState.apiPermissions?.[AppPermissions.CreateDiscountCampaign] ||
      authState.apiPermissions?.[AppPermissions.ViewDiscountCampaign],

    viewRequirement: authState.apiPermissions?.[AppPermissions.ViewRequirement],
    viewRequirementList:
      authState.apiPermissions?.[AppPermissions.ViewRequirementList],
    viewCompany360: authState.apiPermissions?.[AppPermissions.ViewCompany360],
    viewTelecaller360:
      authState.apiPermissions?.[AppPermissions.ViewTelecaller360],

    viewProperty: authState.apiPermissions?.[AppPermissions.ViewProperty],
    viewProject: authState.apiPermissions?.[AppPermissions.ViewProject],

    viewCompanyList: authState.apiPermissions?.[AppPermissions.ViewCompanyList],

    viewOpportunity: authState.apiPermissions?.[AppPermissions.ViewOpportunity],

    viewTransaction360:
      authState.apiPermissions?.[AppPermissions.ViewTransaction360],
    // special Approvals
    ViewProposalsForApprovals:
      authState.apiPermissions?.[AppPermissions.ViewProposalsForApprovals],
    ViewTermsheetsForApprovals:
      authState.apiPermissions?.[AppPermissions.ViewTermsheetsForApprovals],
    ViewFeelettersForApprovals:
      authState.apiPermissions?.[AppPermissions.ViewFeelettersForApprovals],
    ViewLetterofIntentForApprovals:
      authState.apiPermissions?.[AppPermissions.ViewLetterofIntentForApprovals],
    ViewAgreementForApprovals:
      authState.apiPermissions?.[AppPermissions.ViewAgreementForApprovals],
    ViewInvoicesForApprovals:
      authState.apiPermissions?.[AppPermissions.ViewInvoicesForApprovals],
  };

  const menuItems = [];

  if (permissions.viewActivityCalendar) {
    menuItems.push(
      <li>
        <Link
          title="Calendar"
          to={RouteKeys.Calendar}
          className={classnames({
            "d-flex align-items-center dropdown-toggle": true,
            active: history?.location?.pathname === RouteKeys.Calendar,
            in: history?.location?.pathname === RouteKeys.Calendar,
          })}
        >
          <i className="icon-calendar mr-lg-3 mr-2 font-xl"></i>Calendar
        </Link>
      </li>
    );
  }

  if (permissions.viewLeads) {
    menuItems.push(
      <li>
        <Link
          title="Leads"
          to={RouteKeys.Leads}
          className={classnames({
            "d-flex align-items-center dropdown-toggle": true,
            active: history?.location?.pathname === RouteKeys.Leads,
            in: history?.location?.pathname === RouteKeys.Leads,
          })}
          onClick={() => setSideMenu(RouteKeys.Leads)}
        >
          <i className="icon-lead mr-lg-3 mr-2 font-lg"></i>Leads
        </Link>
      </li>
    );
  }

  if (permissions.viewLeads && permissions.viewOpportunity) {
    menuItems.push(
      <li>
        <Link
          title="Opportunities"
          to={RouteKeys.Enquiry}
          className={classnames({
            "d-flex align-items-center dropdown-toggle": true,
            active: history?.location?.pathname === RouteKeys.Enquiry,
            in: history?.location?.pathname === RouteKeys.Enquiry,
          })}
        >
          <i className="icon-briefcase mr-lg-3 mr-2 font-lg"></i>Opportunities
        </Link>
      </li>
    );
  }

  // if (
  //   permissions.viewLeadCustomer360 ||
  //   permissions.viewCompany360 ||
  //   permissions.viewTelecaller360
  // ) {
  //   menuItems.push(
  //     <li title="360 View">
  //       <SideSubMenu
  //         title={"360 View"}
  //         active={
  //           history?.location?.pathname === RouteKeys.Lead360View ||
  //           history?.location?.pathname === RouteKeys.Company360View
  //         }
  //         iconClass="icon-view"
  //       >
  //         {permissions.viewLeadCustomer360 && (
  //           <>
  //             <li>
  //               <Link
  //                 to={RouteKeys.Lead360View}
  //                 className={classnames({
  //                   "d-flex align-items-center dropdown-toggle": true,
  //                   active:
  //                     history?.location?.pathname === RouteKeys.Lead360View,
  //                   in: history?.location?.pathname === RouteKeys.Lead360View,
  //                 })}
  //               >
  //                 Customer 360
  //               </Link>
  //             </li>
  //           </>
  //         )}
  //         {permissions.viewCompany360 && (
  //           <>
  //             <li>
  //               <Link
  //                 to={RouteKeys.Company360View}
  //                 className={classnames({
  //                   "d-flex align-items-center dropdown-toggle": true,
  //                   active:
  //                     history?.location?.pathname === RouteKeys.Company360View,
  //                   in:
  //                     history?.location?.pathname === RouteKeys.Company360View,
  //                 })}
  //               >
  //                 Company 360
  //               </Link>
  //             </li>
  //           </>
  //         )}
  //         {permissions.viewTelecaller360 && (
  //           <>
  //             <li>
  //               <Link
  //                 to={RouteKeys.Company360View}
  //                 className={classnames({
  //                   "d-flex align-items-center dropdown-toggle": true,
  //                   active:
  //                     history?.location?.pathname === RouteKeys.Company360View,
  //                   in:
  //                     history?.location?.pathname === RouteKeys.Company360View,
  //                 })}
  //               >
  //                 Telecaller 360
  //               </Link>
  //             </li>
  //           </>
  //         )}
  //       </SideSubMenu>
  //     </li>
  //   );
  // }
  if (permissions.viewCustomer && permissions.viewAllCustomers) {
    menuItems.push(
      <li>
        <Link
          title="Customers"
          to={RouteKeys.Customers}
          className={classnames({
            "d-flex align-items-center dropdown-toggle": true,
            active: history?.location?.pathname === RouteKeys.Customers,
            in: history?.location?.pathname === RouteKeys.Customers,
          })}
        >
          <i className="icon-users mr-lg-3 mr-2 font-lg"></i>Customers
        </Link>
      </li>
    );
  }
  if (permissions.viewCompanyList) {
    menuItems.push(
      <li>
        <Link
          title="Company"
          to={RouteKeys.Company}
          className={classnames({
            "d-flex align-items-center dropdown-toggle": true,
            active: history?.location?.pathname === RouteKeys.Company,
            in: history?.location?.pathname === RouteKeys.Company,
          })}
        >
          <i className="icon-building mr-lg-3 mr-2 font-xl"></i>Company
        </Link>
      </li>
    );
  }
  if (permissions.viewTransaction360) {
    menuItems.push(
      <li>
        <Link
          title="Transaction 360"
          to={RouteKeys.Transaction360}
          className={classnames({
            "d-flex align-items-center dropdown-toggle": true,
            active: history?.location?.pathname === RouteKeys.Transaction360,
            in: history?.location?.pathname === RouteKeys.Transaction360,
          })}
        >
          <i className="mr-lg-3 mr-2 font-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="25px"
              viewBox="0 -960 960 960"
              width="25px"
              fill={
                history?.location?.pathname === RouteKeys.Transaction360
                  ? "#4161c8"
                  : "#000000"
              }
            >
              <path d="M240-100q-41.92 0-70.96-29.04Q140-158.08 140-199.82V-300h120v-552.31l55.39 47.7 56.15-47.7 56.15 47.7 56.16-47.7 56.15 47.7 56.15-47.7 56.16 47.7 56.15-47.7 56.15 47.7 55.39-47.7V-200q0 41.92-29.04 70.96Q761.92-100 720-100H240Zm480-60q17 0 28.5-11.5T760-200v-560H320v460h360v100q0 17 11.5 28.5T720-160ZM367.69-610v-60h226.92v60H367.69Zm0 120v-60h226.92v60H367.69Zm310-114.62q-14.69 0-25.04-10.34-10.34-10.35-10.34-25.04t10.34-25.04q10.35-10.34 25.04-10.34t25.04 10.34q10.35 10.35 10.35 25.04t-10.35 25.04q-10.35 10.34-25.04 10.34Zm0 120q-14.69 0-25.04-10.34-10.34-10.35-10.34-25.04t10.34-25.04q10.35-10.34 25.04-10.34t25.04 10.34q10.35 10.35 10.35 25.04t-10.35 25.04q-10.35 10.34-25.04 10.34ZM240-160h380v-80H200v40q0 17 11.5 28.5T240-160Zm-40 0v-80 80Z" />
            </svg>
          </i>
          Transaction 360
        </Link>
      </li>
    );
  }

  // if (permissions.viewProject || permissions?.viewProperty) {
  //   menuItems.push(
  //     <li title="Properties">
  //       <SideSubMenu
  //         title={"Properties"}
  //         active={
  //           history?.location?.pathname === RouteKeys.Projects ||
  //           history?.location?.pathname === RouteKeys.Properties
  //         }
  //         iconClass="icon-properties"
  //       >
  //         {permissions.viewProject && (
  //           <li>
  //             <Link
  //               to={RouteKeys.Projects}
  //               className={classnames({
  //                 "d-flex align-items-center dropdown-toggle": true,
  //                 active: history?.location?.pathname === RouteKeys.Projects,
  //                 in: history?.location?.pathname === RouteKeys.Projects,
  //               })}
  //             >
  //               Projects
  //             </Link>
  //           </li>
  //         )}
  //         {permissions?.viewProperty && (
  //           <li>
  //             <Link
  //               to={RouteKeys.Properties}
  //               className={classnames({
  //                 "d-flex align-items-center dropdown-toggle": true,
  //                 active: history?.location?.pathname === RouteKeys.Properties,
  //                 in: history?.location?.pathname === RouteKeys.Properties,
  //               })}
  //             >
  //               Properties{" "}
  //             </Link>
  //           </li>
  //         )}
  //       </SideSubMenu>
  //     </li>
  //   );
  // }

  if (true) {
    menuItems.push(
      <li>
        <SideSubMenu title={"Special Approvals"} iconClass="icon-approval">
          {permissions?.viewRequirementList === true && (
            <li>
              <Link
                to={RouteKeys.Requirements}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.Requirements === location,
                  in: RouteKeys.Requirements === location,
                })}
                // style={{
                //   filter:
                //     history?.location?.pathname === RouteKeys.Requirements
                //       ? "invert(.3) sepia(1) hue-rotate(180deg) saturate(4) brightness(1)"
                //       : "",
                // }}
              >
                {/* <i className=" mr-lg-3 mr-2 font-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M5 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H5M5 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H5"
                      stroke="#272B2A"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.25 5.25H7.25M10 5.25H15.75M4.25 10.25H7.25M10 10.25H15.75M4.25 14.75H7.25M10 14.75H15.75"
                      stroke="#272B2A"
                      stroke-width="1.3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </i> */}
                Requirement
              </Link>
            </li>
          )}

          {permissions?.ViewProposalsForApprovals && (
            <li>
              <Link
                to={RouteKeys.ProposalList}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.ProposalList === location,
                  in: RouteKeys.ProposalList === location,
                })}
              >
                Proposal
              </Link>
            </li>
          )}
          {permissions?.ViewTermsheetsForApprovals && (
            <li>
              <Link
                to={RouteKeys.TermSheetList}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.TermSheetList === location,
                  in: RouteKeys.TermSheetList === location,
                })}
              >
                Term Sheet
              </Link>
            </li>
          )}
          {permissions?.ViewFeelettersForApprovals && (
            <li>
              <Link
                to={RouteKeys.feeLetterList}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.feeLetterList === location,
                  in: RouteKeys.feeLetterList === location,
                })}
              >
                Fee Letter
              </Link>
            </li>
          )}
          {permissions?.ViewLetterofIntentForApprovals && (
            <li>
              <Link
                to={RouteKeys.LetterOfIntentList}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.LetterOfIntentList === location,
                  in: RouteKeys.LetterOfIntentList === location,
                })}
              >
                Letter of Intent
              </Link>
            </li>
          )}
          {permissions?.ViewAgreementForApprovals && (
            <li>
              <Link
                to={RouteKeys.agreementList}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.agreementList === location,
                  in: RouteKeys.agreementList === location,
                })}
              >
                Agreement
              </Link>
            </li>
          )}
          {permissions?.ViewInvoicesForApprovals && (
            <li>
              <Link
                to={RouteKeys.InvoiceList}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.InvoiceList === location,
                  in: RouteKeys.InvoiceList === location,
                })}
              >
                Invoice
              </Link>
            </li>
          )}
        </SideSubMenu>
      </li>
    );
  }

  if (permissions?.tenancyExpiryTracker) {
    menuItems.push(
      <li>
        <Link
          title="tenancyExpiryTracker"
          to={RouteKeys.TenancyExpiryTracker}
          className={classnames({
            "d-flex align-items-center dropdown-toggle": true,
            active:
              history?.location?.pathname === RouteKeys.TenancyExpiryTracker,
            in: history?.location?.pathname === RouteKeys.TenancyExpiryTracker,
          })}
          style={{
            filter:
              history?.location?.pathname === RouteKeys.TenancyExpiryTracker
                ? "invert(.3) sepia(1) hue-rotate(180deg) saturate(4) brightness(1)"
                : "",
          }}
        >
          <i className=" mr-lg-3 mr-2 font-lg">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
                stroke="#272B2A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16 2V6"
                stroke="#272B2A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 2V6"
                stroke="#272B2A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.0002 11.4786V14.0058M12.0002 15.5344H12.006M11.1322 8.87124L6.83519 16.0448C6.7466 16.1982 6.69972 16.3722 6.69922 16.5493C6.69873 16.7265 6.74463 16.9007 6.83236 17.0546C6.9201 17.2086 7.04661 17.3368 7.1993 17.4267C7.352 17.5165 7.52556 17.5648 7.70272 17.5668H16.2968C16.4739 17.5648 16.6475 17.5165 16.8002 17.4267C16.9529 17.3368 17.0794 17.2086 17.1671 17.0546C17.2549 16.9007 17.3008 16.7265 17.3003 16.5493C17.2998 16.3722 17.2529 16.1982 17.1643 16.0448L12.8673 8.87124C12.7768 8.72214 12.6495 8.59886 12.4975 8.51331C12.3456 8.42776 12.1741 8.38281 11.9998 8.38281C11.8254 8.38281 11.6539 8.42776 11.502 8.51331C11.35 8.59886 11.2227 8.72214 11.1322 8.87124Z"
                stroke="#272B2A"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </i>
          Tenancy Expiry Tracker
        </Link>
      </li>
    );
  }

  if (permissions.viewReport) {
    menuItems.push(
      <li>
        <SideSubMenu title={"Reports"} iconClass="icon-pie-chart">
          {/* add site report permission  here*/}
          {true && (
            <li>
              <Link
                to={RouteKeys.SiteVisitReport}
                className={classnames({
                  "d-flex align-items-center font-normal": true,
                  active: RouteKeys.SiteVisitReport === location,
                  in: RouteKeys.SiteVisitReport === location,
                })}
              >
                Activity Summary Report
              </Link>
            </li>
          )}
        </SideSubMenu>
      </li>
    );
  }

  if (
    permissions.viewShowrooms ||
    permissions.viewVisiblityGroup ||
    permissions.viewRoles ||
    permissions.updateStaffMembers ||
    permissions.viewLeadSettings ||
    permissions.updateGeneralSettings ||
    permissions.viewContentSettings
  ) {
    menuItems.push(
      <li title="Settings">
        <SideSubMenu
          title={"Settings"}
          active={
            history?.location?.pathname === RouteKeys.ShowroomManagement ||
            history?.location?.pathname === RouteKeys.RolesAcceessibility ||
            history?.location?.pathname === RouteKeys.Roles ||
            history?.location?.pathname === RouteKeys.StaffMembers ||
            history?.location?.pathname === RouteKeys.LeadSettings ||
            history?.location?.pathname === RouteKeys.CompanySettings ||
            history?.location?.pathname === RouteKeys.RequirementSettings ||
            history?.location?.pathname === RouteKeys.ProposalSettings ||
            history?.location?.pathname === RouteKeys.GeneralSettings
          }
          iconClass="icon-settings"
        >
          <li>
            <Link
              to={RouteKeys.MediaSettings}
              className={classnames({
                "d-flex align-items-center dropdown-toggle": true,
                active: history?.location?.pathname === RouteKeys.MediaSettings,
                in: history?.location?.pathname === RouteKeys.MediaSettings,
              })}
            >
              Media Settings
            </Link>
          </li>
          {permissions.viewShowrooms && (
            <li>
              <Link
                to={RouteKeys.ShowroomManagement}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname ===
                    RouteKeys.ShowroomManagement,
                  in:
                    history?.location?.pathname ===
                    RouteKeys.ShowroomManagement,
                })}
              >
                Office Management & Timing
              </Link>
            </li>
          )}
          {permissions.viewVisiblityGroup && (
            <li>
              <Link
                to={RouteKeys.RolesAcceessibility}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname ===
                    RouteKeys.RolesAcceessibility,
                  in:
                    history?.location?.pathname ===
                    RouteKeys.RolesAcceessibility,
                })}
              >
                Visibility Group
              </Link>
            </li>
          )}
          {permissions.viewRoles && (
            <li>
              <Link
                to={RouteKeys.Roles}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active: history?.location?.pathname === RouteKeys.Roles,
                  in: history?.location?.pathname === RouteKeys.Roles,
                })}
              >
                Roles
              </Link>
            </li>
          )}
          {permissions.viewStaffMembers && (
            <li>
              <Link
                to={RouteKeys.StaffMembers}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname === RouteKeys.StaffMembers,
                  in: history?.location?.pathname === RouteKeys.StaffMembers,
                })}
              >
                Staff Members
              </Link>
            </li>
          )}
          {permissions.viewLeadSettings && (
            <li>
              <Link
                to={RouteKeys.LeadSettings}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname === RouteKeys.LeadSettings,
                  in: history?.location?.pathname === RouteKeys.LeadSettings,
                })}
              >
                Lead Settings
              </Link>
            </li>
          )}
          {permissions.viewLeadSettings && (
            <li>
              <Link
                to={RouteKeys.CompanySettings}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname === RouteKeys.CompanySettings,
                  in: history?.location?.pathname === RouteKeys.CompanySettings,
                })}
              >
                Company Settings
              </Link>
            </li>
          )}
          {permissions.viewLeadSettings && (
            <li>
              <Link
                to={RouteKeys.RequirementSettings}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname ===
                    RouteKeys.RequirementSettings,
                  in:
                    history?.location?.pathname ===
                    RouteKeys.RequirementSettings,
                })}
              >
                Requirement Settings
              </Link>
            </li>
          )}
          {/* {permissions?.viewInvoiceSettings && ( */}
          {true && (
            <li>
              <Link
                to={RouteKeys.InvoiceSettings}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname === RouteKeys.InvoiceSettings,
                  in: history?.location?.pathname === RouteKeys.InvoiceSettings,
                })}
              >
                Invoice Settings
              </Link>
            </li>
          )}
          {permissions.viewLeadSettings && (
            <li>
              <Link
                to={RouteKeys.ProposalSettings}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname === RouteKeys.ProposalSettings,
                  in:
                    history?.location?.pathname === RouteKeys.ProposalSettings,
                })}
              >
                Proposal Settings
              </Link>
            </li>
          )}
          {permissions.viewLeadSettings && (
            <>
              <li>
                <Link
                  to={RouteKeys.DocumentSettings}
                  className={classnames({
                    "d-flex align-items-center dropdown-toggle": true,
                    active:
                      history?.location?.pathname ===
                      RouteKeys.DocumentSettings,
                    in:
                      history?.location?.pathname ===
                      RouteKeys.DocumentSettings,
                  })}
                >
                  Document Settings
                </Link>
              </li>

              <li>
                <Link
                  to={RouteKeys.LegalDueDiligenceSettings}
                  className={classnames({
                    "d-flex align-items-center dropdown-toggle": true,
                    active:
                      history?.location?.pathname ===
                      RouteKeys.LegalDueDiligenceSettings,
                    in:
                      history?.location?.pathname ===
                      RouteKeys.LegalDueDiligenceSettings,
                  })}
                >
                  Legal Due Diligence Settings
                </Link>
              </li>
            </>
          )}

          {permissions.updateGeneralSettings && (
            <li>
              <Link
                to={RouteKeys.GeneralSettings}
                className={classnames({
                  "d-flex align-items-center dropdown-toggle": true,
                  active:
                    history?.location?.pathname === RouteKeys.GeneralSettings,
                  in: history?.location?.pathname === RouteKeys.GeneralSettings,
                })}
              >
                General Settings
              </Link>
            </li>
          )}
          {(permissions.viewContentSettings ||
            permissions.updateGeneralSettings) && (
            <li>
              <Link
                to={RouteKeys.ContentSettings}
                className="d-flex align-items-center font-normal"
              >
                Content Settings
              </Link>
            </li>
          )}
        </SideSubMenu>
      </li>
    );
  }

  return (
    <div className="sidemenu-inner" ref={props?.sidemenuRef}>
      <div className="menu-control bg-white d-flex p-lg-3">
        <span
          className="py-1 cursor-pointer w-100 pl-1"
          onClick={() => {
            // if (props.showOpenHideMenu) {
            //   props.onMenuClose?.();
            // }
            ui.changeSideMenuExpandedStatus(!ui.sideMenuExpanded);
          }}
        >
          {!props.showOpenHideMenu && <i className="icon-menu font-xs"></i>}

          <i className="icon-close"></i>
        </span>
      </div>
      <ul className="list-unstyled p-0 m-0 menu-list dd">
        <li>
          <Link
            title="Dashboard"
            to={RouteKeys.Home}
            className={classnames({
              "d-flex align-items-center dropdown-toggle": true,
              active: history?.location?.pathname === RouteKeys.Home,
              in: history?.location?.pathname === RouteKeys.Home,
            })}
            style={{
              filter:
                history?.location?.pathname === RouteKeys.Home
                  ? "invert(.3) sepia(1) hue-rotate(180deg) saturate(4) brightness(1)"
                  : "",
            }}
          >
            <i className="icon-dashboard mr-lg-3 mr-2 font-lg">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </i>
            Dashboard
          </Link>
        </li>
        {menuItems.length > 0 && <>{menuItems}</>}
      </ul>
    </div>
  );
};

export default SideMenu;
